<template>
  <router-view />
</template>
<script>
import { defineComponent } from "vue";

// import layOut from "@/layouts/LayoutIndex.vue";
export default defineComponent({
  // components: {
  //   layOut,
  // },
  setup() {
    return {
      data: 1,
    };
  },
});
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
